export default __webpack_public_path__ + "583175b6813761a30b9b78dce0a54258.svg";